module.exports = __webpack_public_path__ + "img/Agustin-Diaz-Portales.b63044b4.jpg";